export enum CooldownActionTypes {
  COOLDOWN_RECALCULATED = 'cooldown/COOLDOWN_RECALCULATED',
  RESET_SUCCESS = 'cooldown/RESET_SUCCESS',
  RESET_REQUEST = 'cooldown/RESET_REQUEST',
  RESET_ERROR = 'cooldown/RESET_ERROR',
  UPDATED_ERROR = 'cooldown/UPDATED_ERROR',
  UPDATED_SUCCESS = 'cooldown/UPDATED_SUCCESS',
  UPDATED_REQUEST = 'cooldown/UPDATED_REQUEST',
}
